module.exports = __webpack_public_path__ + "img/user.2b5f32a9.png";